/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BasePageFrame from "./BasePageFrame";
import {Modal} from "../../../components/Bootstrap";
import Navigation from "../../../Navigation";

class ModalFrame extends BasePageFrame {
    static propTypes = {
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        options: PropTypes.shape({
            component: PropTypes.string.isRequired,
            schema: PropTypes.string
        }).isRequired
    };

    static defaultProps = {};

    getFrame() {
        return [false];
    }

    renderBody() {
        return this.getPageComponent();
    }
}

export default ModalFrame;
